import PropTypes from "prop-types";
import classnames from "classnames";
import styles from "./index.css";
import { useState } from "react";

const srcSetList = [
  [240, 120],
  [240, 238],
  [320, 317],
  [480, 476],
  [640, 634],
  [750, 714],
  [960, 952]
];

const buildImageSrc = src => `//${src}?$n_480w$&wid=476&fit=constrain`;

const getSrcSet = src =>
  srcSetList
    .map(
      ([presetSize, ourSize]) =>
        `//${src}?$n_${presetSize}w$&wid=${ourSize}&fit=constrain ${ourSize}w`
    )
    .join(",");

const Image = ({ className, src, onLoad, hasSecondImageOnHover }) => {
  const [hovered, setHovered] = useState(false);
  const [ready, setReady] = useState(false);
  const secondarySrc = src.replace(/-1-.*/, "-2");

  return (
    <>
      <img
        alt={""}
        className={classnames(className, styles.image)}
        sizes="(min-width: 768px) 317px, 238px"
        src={buildImageSrc(src)}
        srcSet={getSrcSet(src)}
        onLoad={onLoad}
        onMouseOver={hasSecondImageOnHover ? () => setHovered(true) : null}
      />
      {hovered ? (
        <img
          alt={""}
          className={classnames(styles.image, styles.secoundImage, {
            [styles.fade]: ready
          })}
          sizes={"(min-width: 768px) 317px, 238px"}
          src={buildImageSrc(secondarySrc)}
          srcSet={getSrcSet(secondarySrc)}
          onMouseLeave={() => setHovered(false)}
          onLoad={() => setReady(true)}
          onError={e => (e.target.style.display = "none")}
        />
      ) : null}
    </>
  );
};

Image.propTypes = {
  className: PropTypes.string,
  onLoad: PropTypes.func,
  src: PropTypes.string.isRequired,
  hasSecondImageOnHover: PropTypes.bool
};

Image.defaultProps = {
  onLoad: () => {}
};

export default Image;
